import React from 'react';
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Divider,
} from '@chakra-ui/react';
import FeedbackForm from './FeedbackForm';

const FeedbackModal = (props) => {
    const { isOpen, onOpen, onClose } = props;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalContent mx={3} shadow='dark-lg' position='absolute' left={2} right={2} bottom={6} w='auto'>
                <ModalHeader fontWeight={700} fontSize={16} pr={12}>
                    Please provide your feedback
                </ModalHeader>
                <ModalCloseButton />
                <Divider />
                <ModalBody>
                    <FeedbackForm />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default FeedbackModal;
